import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ApiResponse,
  PageResponse,
  ServiceCatalogResponse,
  RegisterServiceRequest,
  UpdateServiceRequest
} from '../models/models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServiceCatalogService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getActiveServices(): Observable<ApiResponse<ServiceCatalogResponse[]>> {
    return this.http.get<ApiResponse<ServiceCatalogResponse[]>>(`${this.apiUrl}/services`);
  }

  getAllServices(): Observable<ApiResponse<ServiceCatalogResponse[]>> {
    return this.http.get<ApiResponse<ServiceCatalogResponse[]>>(`${this.apiUrl}/services/all`);
  }

  getServicesPaged(params?: { status?: string; search?: string; page?: number; size?: number }): Observable<ApiResponse<PageResponse<ServiceCatalogResponse>>> {
    const queryParts: string[] = [];
    if (params?.status) queryParts.push(`status=${encodeURIComponent(params.status)}`);
    if (params?.search) queryParts.push(`search=${encodeURIComponent(params.search)}`);
    if (params?.page !== undefined) queryParts.push(`page=${params.page}`);
    if (params?.size !== undefined) queryParts.push(`size=${params.size}`);
    const query = queryParts.length > 0 ? `?${queryParts.join('&')}` : '';
    return this.http.get<ApiResponse<PageResponse<ServiceCatalogResponse>>>(`${this.apiUrl}/services/paged${query}`);
  }

  registerService(request: RegisterServiceRequest): Observable<ApiResponse<ServiceCatalogResponse>> {
    return this.http.post<ApiResponse<ServiceCatalogResponse>>(`${this.apiUrl}/services`, request);
  }

  updateService(uid: string, request: UpdateServiceRequest): Observable<ApiResponse<ServiceCatalogResponse>> {
    return this.http.put<ApiResponse<ServiceCatalogResponse>>(`${this.apiUrl}/services/${uid}`, request);
  }

  deleteService(uid: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/services/${uid}`);
  }

  getServicesByInstitution(institutionUid: string): Observable<ApiResponse<ServiceCatalogResponse[]>> {
    return this.http.get<ApiResponse<ServiceCatalogResponse[]>>(`${this.apiUrl}/services/institution/${institutionUid}`);
  }

  getServiceByUid(uid: string): Observable<ApiResponse<ServiceCatalogResponse>> {
    return this.http.get<ApiResponse<ServiceCatalogResponse>>(`${this.apiUrl}/services/${uid}`);
  }

  approveService(uid: string): Observable<ApiResponse<ServiceCatalogResponse>> {
    return this.http.post<ApiResponse<ServiceCatalogResponse>>(`${this.apiUrl}/approve-service/${uid}`, {});
  }

  syncServices(institutionUid?: string): Observable<ApiResponse<ServiceCatalogResponse[]>> {
    const params = institutionUid ? `?institutionUid=${institutionUid}` : '';
    return this.http.post<ApiResponse<ServiceCatalogResponse[]>>(`${this.apiUrl}/services/sync${params}`, {});
  }
}
